import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  id?: string;
  className?: string;
  selectedValue?: string;
  type?:
    | 'type1'
    | 'type2'
    | 'type3'
    | 'type4'
    | 'type5'
    | 'type6'
    | 'type7'
    | 'type8' // 기본2
    | 'type9' // 기본3
    | 'type10' // 기본4
    | 'type11' // 기본5
    | 'type12'; // PC 구분선 박스형
  // type1: 기본, type2: square, type3: round, type4: text, type5: underBar, type6: round white, type7: underBar small, type8: 기본2, type9: 기본3, type10: 기본4, type11: 기본5
  $bgType?: 'white' | 'black' | undefined;
  items?: React.ReactNode;
}

export const CategoryMenuBar = styled.div<IProps>`
  .fold-menubar {
    ${mixin.flex({ align: 'center', justify: 'flex-start' })}

    .area-left + .menubar-swiper .swiper {
      padding: 0 20px 0 0;
    }
  }

  .swiper {
    padding: 0 20px;
  }

  ${props => {
    switch (props.type) {
      case 'type1':
        return css`
          position: relative;
          background-color: #fff;
          overflow: hidden;
          padding-bottom: 10px;

          .menubar-swiper {
            background-color: #fff;
          }

          .swiper {
            height: 33px;
          }

          .item {
            .area-click {
              height: inherit;
              margin: 0 6px;
              padding: 0;
              border-radius: 38px;
              color: #999;
            }

            &.active .area-click {
              padding-right: 12px;
              padding-left: 12px;
              background-color: #000;
              color: #fff;
            }
          }

          .swiper-slide {
            &:first-child {
              .area-click {
                margin-left: 0;
              }
            }

            &:last-child {
              .area-click {
                margin-right: 0;
              }
            }
          }
        `;
      case 'type2':
        return css`
          position: relative;
          padding: 12px 0;
          background-color: #fff;
          overflow: hidden;

          .menubar-swiper {
            background-color: #fff;
          }

          .swiper {
            .swiper-slide {
              margin-right: 6px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  height: 29px;
                  border: 1px solid #eee;
                  border-radius: 6px;
                  font-size: 13px;
                  color: #000;
                  font-weight: 400;
                }

                &.active {
                  .area-click {
                    border: 1px solid #000;
                    color: #000;
                  }
                }

                .icon-my {
                  width: 13.9px;
                  height: 8px;
                  margin-right: 3px;
                }
              }
            }
          }
        `;
      case 'type3':
        return css`
          border-top: none;
          padding-bottom: 10px;

          .swiper {
            .swiper-slide {
              margin-right: 6px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  height: 34px;
                  padding: 0 12px;
                  border: none;
                  border-radius: 100px;
                  font-size: 14px;
                  color: #999;
                  background-color: #f4f4f4;
                }

                &.active {
                  .area-click {
                    border: none;
                    color: #fff;
                    background-color: #000;
                  }
                }
              }
            }
          }
        `;
      case 'type4':
        return css`
          position: relative;
          width: 100%;
          padding: 12px 0;
          background-color: #f6f6f6;
          overflow: hidden;

          .swiper {
            background-color: #f6f6f6;

            .swiper-slide {
              margin-right: 12px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  height: auto;
                  padding: 0;
                  border-radius: 0;
                  font-size: 13px;
                  color: #999;
                }

                &.active {
                  .area-click {
                    color: #000;
                    font-weight: 600;
                  }
                }
              }
            }
          }
        `;
      case 'type5':
        return css`
          .swiper {
            height: 50px;
            background: #fff;

            .swiper-slide {
              margin-right: 16px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  font-size: 15px;
                  font-weight: 500;
                  padding: 0;
                  color: #999;
                }

                &.active {
                  .area-click {
                    color: #000;

                    &:after {
                      content: '';
                      display: block;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      width: 100%;
                      height: 2px;
                      background: #000;
                    }
                  }
                }
              }
            }
            &:after {
              content: '';
              display: block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 1px;
              background: #eee;
            }
          }
        `;
      case 'type6':
        return css`
          .swiper {
            .swiper-slide {
              margin-right: 5px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  height: 32px;
                  padding: 0 12px;
                  font-size: 14px;
                  color: #000;
                  background: #fff;
                  border: 1px solid #eee;
                  border-radius: 30px;
                }

                &.active {
                  .area-click {
                    border-color: #000;
                    color: #fff;
                    background-color: #000;
                  }
                }
              }
            }
          }
        `;
      case 'type7':
        return css`
          .menubar-swiper {
            background: transparent;
          }

          .swiper {
            height: 38px;

            .swiper-slide {
              margin-right: 16px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  font-size: 14px;
                  font-weight: 500;
                  padding: 0;
                  color: #999;
                }

                &.active {
                  .area-click {
                    color: #000;
                    font-weight: 600;

                    &:after {
                      content: '';
                      display: block;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      width: 100%;
                      height: 2px;
                      background: #000;
                    }
                  }
                }
              }
            }
            &:after {
              content: '';
              display: block;
              position: absolute;
              bottom: 0;
              left: 20px;
              width: calc(100% - 40px);
              height: 1px;
              background: #eee;
            }
          }
        `;
      case 'type8':
        return css`
          position: relative;
          background-color: #fff;
          overflow: hidden;
          padding-top: 12px;
          padding-bottom: 12px;

          .menubar-swiper {
            background-color: #fff;
          }

          .swiper {
            height: 32px;
          }

          .item {
            .area-click {
              height: inherit;
              margin: 0 7px;
              padding: 0;
              border-radius: 38px;
              font-size: 14px;
              font-weight: 600;
              color: #999;
            }

            &.active .area-click {
              padding-right: 12px;
              padding-left: 12px;
              border: 1px solid #000;
              color: #000;
            }
          }

          .swiper-slide {
            &:first-child {
              .area-click {
                margin-left: 0;
              }
            }

            &:last-child {
              .area-click {
                margin-right: 0;
              }
            }
          }
        `;
      case 'type9':
        return css`
          position: relative;
          width: 100%;
          padding: 16px 0;
          background-color: #fff;
          overflow: hidden;

          .swiper {
            background-color: #fff;

            .swiper-slide {
              margin-right: 12px;

              &:last-child {
                margin-right: 0;
              }

              .item {
                .area-click {
                  height: auto;
                  padding: 0;
                  border-radius: 0;
                  font-size: 14px;
                  color: #999;
                }

                &.active {
                  .area-click {
                    color: #000;
                    font-weight: 600;
                  }
                }
              }
            }
          }
        `;
      case 'type10':
        return css`
          position: relative;
          background-color: #fff;
          overflow: hidden;

          .menubar-swiper {
            background-color: #fff;
          }

          .swiper {
            height: 32px;
          }

          .item {
            .area-click {
              height: inherit;
              margin: 0 7px;
              padding: 0;
              border-radius: 100px;
              color: #777;
              font-size: 14px;
              font-weight: 600;
              line-height: 130%;
            }

            &.active .area-click {
              padding-right: 12px;
              padding-left: 12px;
              border: 1px solid #000;
              background-color: #fff;
              color: #000;
            }
          }

          .swiper-slide {
            &:first-child {
              .area-click {
                margin-left: 0;
              }
            }

            &:last-child {
              .area-click {
                margin-right: 0;
              }
            }
          }
        `;
      case 'type11':
        return css`
          padding-bottom: 8px;

          /* 슬라이드 간격은 스와이프 경로 전용 (줄바꿈 경로는 WrapMenuBar 의 column-gap) */
          .swiper .swiper-slide {
            margin-right: 6px;

            &:last-child {
              margin-right: 0;
            }
          }

          /* 탭 스킨은 스와이퍼 밖(WrapMenuBar)에서도 먹도록 .item 기준으로 잡는다 */
          .item {
            .area-click {
              height: 34px;
              padding: 0 12px;
              border-radius: 100px;
              font-size: 14px;
              font-weight: 500;
              color: #999;
              background-color: #f4f4f4;
            }

            &.active {
              .area-click {
                color: #fff;
                background-color: #000;
                font-weight: 600;
              }
            }
          }
        `;
      case 'type12':
        return css`
          /* PC 퀵메뉴 : 한 박스 안에 세로 구분선으로 나뉜 텍스트 메뉴.
             스와이프 없이 줄바꿈(WrapMenuBar)으로만 흘린다 */
          border: 1px solid #eee;
          background-color: #fff;

          /* 한 줄에 7칸 고정 : 퍼센트 폭은 소수점 반올림으로 7번째 칸이 밀릴 수 있어 grid 로 나눈다 */
          .wrap-menubar .wrap-menubar-list {
            display: grid;
            grid-template-columns: repeat(7, minmax(0, 1fr));
          }

          .item {
            position: relative;

            .area-click {
              width: 100%;
              height: 56px;
              padding: 10px;
              border-radius: 0;
              font-size: 18px;
              font-weight: 500;
              color: #777;
            }

            /* 칸 구분선 : 줄의 마지막 칸(7번째)과 전체 마지막 아이템에는 붙이지 않는다 */
            &::after {
              content: '';
              position: absolute;
              top: 50%;
              right: 0;
              width: 1px;
              height: 16px;
              transform: translateY(-50%);
              background-color: #ddd;
            }

            &:nth-child(7n)::after,
            &:last-child::after {
              display: none;
            }

            &.active .area-click {
              color: #000;
              font-weight: 600;
            }
          }
        `;
      default:
        break;
    }

    return null;
  }}

  ${props => {
    if (props.$bgType === 'black') {
      switch (props.type) {
        case 'type1':
          return css`
            background-color: #1a1a1a;

            .menubar-swiper {
              background-color: transparent;
            }

            .item {
              .area-click {
                color: #777;
              }

              &.active .area-click {
                background-color: #fff;
                color: #000;
              }
            }
          `;
        case 'type2':
          return css`
            border-top: 1px solid #333;
            background-color: #1a1a1a;

            .menubar-swiper {
              background-color: transparent;
            }

            .swiper {
              .item {
                .area-click {
                  border: 1px solid #333;
                  color: #777;
                }

                &.active {
                  .area-click {
                    border: 1px solid #fff;
                    color: #fff;
                  }
                }
              }
            }
          `;
        case 'type3':
          return css`
            .swiper {
              .swiper-slide {
                .item {
                  .area-click {
                    color: #777;
                    background-color: #333;
                  }

                  &.active {
                    .area-click {
                      color: #000;
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          `;
        case 'type4':
          return css`
            background-color: #1a1a1a;

            .swiper {
              background-color: #1a1a1a;

              .swiper-slide {
                .item {
                  .area-click {
                    color: #777;
                  }

                  &.active {
                    .area-click {
                      color: #fff;
                    }
                  }
                }
              }
            }
          `;
        case 'type7':
          return css`
            .swiper {
              .swiper-slide {
                .item {
                  .area-click {
                    color: #777;
                  }

                  &.active {
                    .area-click {
                      color: #fff;

                      &:after {
                        background: #fff;
                      }
                    }
                  }
                }
              }

              &:after {
                background: #333;
              }
            }
          `;
        case 'type11':
          return css`
            .item {
              .area-click {
                color: #777;
                background-color: #333;
              }

              &.active {
                .area-click {
                  color: #000;
                  background-color: #fff;
                }
              }
            }
          `;
        default:
          return null;
      }
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .swiper {
      padding: ${mixin.pxToVw('0 20')};
    }

    ${props => {
      switch (props.type) {
        case 'type1':
          return css`
            padding-bottom: ${mixin.pxToVw('16')};

            .swiper {
              height: ${mixin.pxToVw('33')};
            }

            .item {
              .area-click {
                margin: ${mixin.pxToVw('0 6')};
                border-radius: ${mixin.pxToVw('38')};
              }
              &.active .area-click {
                padding-right: ${mixin.pxToVw('10')};
                padding-left: ${mixin.pxToVw('10')};
              }
            }
          `;
        case 'type2':
          return css`
            padding: ${mixin.pxToVw('12 0')};

            .swiper {
              .swiper-slide {
                margin-right: ${mixin.pxToVw('6')};

                .item {
                  .area-click {
                    height: ${mixin.pxToVw('29')};
                    font-size: ${mixin.pxToVw('13')};
                    border-radius: ${mixin.pxToVw('6')};
                  }

                  .icon-my {
                    width: ${mixin.pxToVw('13.9')};
                    height: ${mixin.pxToVw('8')};
                    margin-right: ${mixin.pxToVw('3')};
                  }
                }
              }
            }
          `;
        case 'type3':
          return css`
            .swiper {
              .swiper-slide {
                margin-right: ${mixin.pxToVw('6')};

                .item {
                  .area-click {
                    height: ${mixin.pxToVw('34')};
                    padding: ${mixin.pxToVw('0 12')};
                    border-radius: ${mixin.pxToVw('100')};
                    font-size: ${mixin.pxToVw('14')};
                  }
                }
              }
            }
          `;
        case 'type4':
          return css`
            padding: ${mixin.pxToVw('12 0')};

            .swiper {
              .swiper-slide {
                margin-right: ${mixin.pxToVw('12')};

                .item {
                  .area-click {
                    height: auto;
                    font-size: ${mixin.pxToVw('13')};
                  }
                }
              }
            }
          `;
        case 'type5':
          return css`
            .swiper {
              height: ${mixin.pxToVw('49')};

              .swiper-slide {
                margin-right: ${mixin.pxToVw('16')};

                .item {
                  .area-click {
                    font-size: ${mixin.pxToVw('15')};
                  }
                }
              }
            }
          `;
        case 'type6':
          return css`
            .swiper {
              .swiper-slide {
                margin-right: ${mixin.pxToVw('5')};

                .item {
                  .area-click {
                    height: ${mixin.pxToVw('32')};
                    padding: ${mixin.pxToVw('0 12')};
                    font-size: ${mixin.pxToVw('14')};
                    border-radius: ${mixin.pxToVw('30')};
                  }
                }
              }
            }
          `;
        case 'type7':
          return css`
            .swiper {
              height: ${mixin.pxToVw('38')};

              .swiper-slide {
                margin-right: ${mixin.pxToVw('16')};

                .item {
                  .area-click {
                    font-size: ${mixin.pxToVw('14')};
                  }
                }
              }
              &:after {
                left: ${mixin.pxToVw('20')};
                width: calc(100% - ${mixin.pxToVw('40')});
              }
            }
          `;
        case 'type8':
          return css`
            padding-top: ${mixin.pxToVw('12')};
            padding-bottom: ${mixin.pxToVw('12')};

            .swiper {
              height: ${mixin.pxToVw('32')};
            }

            .item {
              .area-click {
                height: inherit;
                margin: ${mixin.pxToVw('0 7')};
                border-radius: ${mixin.pxToVw('38')};
                font-size: ${mixin.pxToVw('14')};
              }

              &.active .area-click {
                padding-right: ${mixin.pxToVw('12')};
                padding-left: ${mixin.pxToVw('12')};
              }
            }
          `;
        case 'type9':
          return css`
            padding: ${mixin.pxToVw('16 0')};

            .swiper {
              .swiper-slide {
                margin-right: ${mixin.pxToVw('12')};

                .item {
                  .area-click {
                    font-size: ${mixin.pxToVw('14')};
                  }
                }
              }
            }
          `;
        case 'type10':
          return css`
            .swiper {
              height: ${mixin.pxToVw('32')};
            }

            .item {
              .area-click {
                height: inherit;
                margin: ${mixin.pxToVw('0 7')};
                border-radius: ${mixin.pxToVw('100')};
                font-size: ${mixin.pxToVw('14')};
              }

              &.active .area-click {
                padding-right: ${mixin.pxToVw('12')};
                padding-left: ${mixin.pxToVw('12')};
              }
            }
          `;
        case 'type11':
          return css`
            padding-bottom: ${mixin.pxToVw('8')};

            .swiper .swiper-slide {
              margin-right: ${mixin.pxToVw('6')};
            }

            .item {
              .area-click {
                height: ${mixin.pxToVw('34')};
                padding: ${mixin.pxToVw('0 12')};
                border-radius: ${mixin.pxToVw('100')};
                font-size: ${mixin.pxToVw('14')};
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    ${props => {
      switch (props.type) {
        case 'type1':
          return css`
            padding-bottom: 20px;

            .swiper {
              padding: 0px;
              height: 38px;
            }
            .item {
              .area-click {
                margin: 0 7px;
                font-size: 17px;
                color: #999;
              }
              &.active .area-click {
                padding-right: 18px;
                padding-left: 18px;
                color: #fff;
              }
            }
          `;
        case 'type2':
          return css``;
        case 'type3':
          return css`
            padding: 0;
            border-top: none;

            .swiper {
              padding: 0;

              .swiper-slide {
                margin-right: 10px;

                &:last-child {
                  margin-right: 0;
                }

                .item {
                  .area-click {
                    height: 46px;
                    padding: 0 22px;
                    border: none;
                    font-size: 17px;
                    color: #555;
                    background-color: #f6f6f6;
                  }

                  &.active {
                    .area-click {
                      border: none;
                      color: #fff;
                      background-color: #000;

                      .icon-my {
                        path {
                          transition: fill 0.3s;
                          fill: #fff;
                        }
                      }
                    }
                  }

                  .icon-my {
                    width: 25px;
                    height: 13px;
                    margin-right: 2px;
                  }
                }
              }
            }
          `;
        case 'type4':
          return css`
            padding: 0;
            background-color: transparent;

            .swiper {
              padding: 0 22px;
              background-color: transparent;

              .swiper-slide {
                margin-right: 28px;

                &:last-child {
                  margin-right: 0;
                }

                .item {
                  .area-click {
                    height: 50px;
                    font-size: 17px;
                    color: #999;
                  }

                  &.active {
                    .area-click {
                      color: #000;
                    }
                  }
                }
              }
            }
          `;
        case 'type5':
          return css`
            .swiper {
              height: 34px;
              border-bottom: none;
              padding: 0;

              .swiper-slide {
                margin-right: 28px;

                .item {
                  .area-click {
                    font-size: 26px;
                    font-weight: 600;
                    color: #ccc;
                  }

                  &.active {
                    .area-click:after {
                      display: none;
                    }
                  }
                }
              }
              &:after {
                display: none;
              }
            }
          `;
        case 'type7':
          return css`
            .swiper {
              height: 44px;
              padding: 0;

              .swiper-slide {
                margin-right: 28px;

                .item {
                  .area-click {
                    font-size: 18px;
                  }

                  &.active {
                    .area-click {
                      &:after {
                        height: 3px;
                      }
                    }
                  }
                }
              }

              &:after {
                left: 0;
                width: 100%;
              }
            }
          `;
        case 'type11':
          return css`
            padding-bottom: 16px;

            .swiper .swiper-slide {
              margin-right: 8px;
            }

            .item {
              .area-click {
                height: 41px;
                padding: 0 24px;
                font-size: 16px;
                color: #777;
                font-weight: 600;
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  ${props => {
    if (props.$bgType === 'black') {
      switch (props.type) {
        case 'type1':
          return css`
            background-color: #1a1a1a;

            .menubar-swiper {
              background-color: transparent;
            }

            .item {
              .area-click {
                color: #777;
              }

              &.active .area-click {
                background-color: #fff;
                color: #000;
              }
            }

            &.is-grdnt-right:after,
            &.is-grdnt-left:before {
              content: '';
              display: block;
              width: 40px;
              height: 40px;
              position: absolute;
              z-index: 2;
              pointer-events: none;
              top: 0;
            }

            &.is-grdnt-left:before {
              left: 0;
              background: linear-gradient(
                to right,
                #1a1a1a 0%,
                rgba(26, 26, 26, 0) 100%
              );
            }

            &.is-grdnt-right:after {
              right: 0;
              background: linear-gradient(
                to left,
                #1a1a1a 0%,
                rgba(26, 26, 26, 0) 100%
              );
            }
          `;
        case 'type2':
          return css`
            border-top: 1px solid #333;
            background-color: #1a1a1a;

            .menubar-swiper {
              background-color: transparent;
            }

            .swiper {
              .item {
                .area-click {
                  border: 1px solid #333;
                  color: #777;
                }

                &.active {
                  .area-click {
                    border: 1px solid #fff;
                    color: #fff;
                  }
                }
              }
            }
          `;
        case 'type3':
          return css`
            .swiper {
              .swiper-slide {
                .item {
                  .area-click {
                    color: #777;
                    background-color: #333;
                  }

                  &.active {
                    .area-click {
                      color: #000;
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          `;
        case 'type4':
          return css`
            border-top: 1px solid #333;
            background-color: #1a1a1a;

            .swiper {
              background-color: #1a1a1a;

              .swiper-slide {
                .item {
                  .area-click {
                    color: #777;
                  }

                  &.active {
                    .area-click {
                      color: #fff;
                    }
                  }
                }
              }
            }
          `;
        default:
          return null;
      }
    }
    return null;
  }}
`;

export const Left = styled.span<IProps>`
  min-width: 58px;
  padding-left: 20px;
  flex: none;
  z-index: 1;

  .btn {
    width: 28px;
    height: 28px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    min-width: ${mixin.pxToVw('58')};
    padding-left: ${mixin.pxToVw('20')};
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0px 10px 0px 0px;
    min-width: auto;
    z-index: 2;

    svg {
      width: 36px;
      height: 36px;
    }
  }
`;
